<div class="rounded-input box-border flex w-full p-4 text-base">
  @let hasError = ngControl.errors && ngControl.touched;
  <div class="group relative box-border flex gap-8 bg-inherit">
    @for (
      option of languageService.languages;
      track $index;
      let index = $index
    ) {
      <label
        [attr.data-testid]="id() + index | appendTestId: 'label'"
        (click)="selectOption(option.prefix)"
        class="flex cursor-pointer items-center">
        <input
          [attr.data-testid]="id() + index | appendTestId: 'input'"
          [formControl]="ngControl.control! | toFormControl"
          [id]="id() + index"
          [value]="option.prefix"
          type="radio"
          class="hidden h-5 w-5 border-2"
          [ngClass]="{
            'border-input-error focus:border-input-focus': hasError,
            'border-input-ring focus:border-input-focus': !hasError,
          }"
          [name]="id() + index" />
        <div
          class="flex h-10 flex-col justify-center"
          [ngClass]="{
            'border-input-focus text-input-focus border-b-2':
              option.prefix === languageService.activeLanguage().prefix,
          }"
          [attr.data-testid]="id() + index | appendTestId: 'option'">
          {{ option.name }}
        </div>
      </label>
    }
  </div>
  @if (hasError && !errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-content></ng-content>
    </aw-error-message>
  }
  @if (hasError && errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
    </aw-error-message>
  }
</div>
